module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXAQMAAABd1a/lAAAABlBMVEUAAAAAOD8EnigJAAAAAXRSTlMAQObYZgAAABNJREFUCNdj+A8Ef1BIogF19QIADwwsuffXMX8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/mobile/caidan.png
// module id = q4dg
// module chunks = 1